module.exports = __webpack_public_path__ + "img/luechai6logos.45d3ef7b.png";